import React from "react";

interface DashboardBoxProps {
  title: string;
  mainText: string;
  subText: string;
}

const DashboardBox: React.FC<DashboardBoxProps> = ({
  title,
  mainText,
  subText,
}) => {
  return (
    <div
      className="rounded-lg p-4 text-white shadow-md"
      style={{
        background: "linear-gradient(135deg, #5571ad 0%, #889bc5 100%)",
      }}
    >
      <div className="text-base opacity-90">{title}</div>
      <div className="text-2xl font-bold mt-1">{mainText}</div>
      <div className="text-base opacity-90 mt-1">{subText}</div>
    </div>
  );
};

export default DashboardBox;
